import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    BehaviorSubject,
    Observable,
    filter,
    map,
    shareReplay,
    switchMap,
    tap,
} from 'rxjs';
import { SpswModel } from '../models/spsw.model';
import { YouthWorkerModel } from '../models/youth-workers.model';
import { NewAsset } from '../models/asset.model';
import { StudentProfile } from '../models/Student Models/student-profile.model';

@Injectable({
    providedIn: 'root',
})
export class StudentPortalService {
    constructor(private _http: HttpClient) {}

    portalController = '/api/portal';
    private studentId: number = null;
    public studentByEmailExecuted = new BehaviorSubject<boolean>(false);
    studentByEmailExecuted$ = this.studentByEmailExecuted.asObservable();
    getStudentIdByEmail(): Observable<number> {
        return this._http
            .get<number>(`${this.portalController}/GetStudentIdByEmail`)
            .pipe(
                tap(() => {
                    this.studentByEmailExecuted.next(true);
                })
            );
    }

    getStudentDob(): Observable<any> {
        return this._http.get<any>(`${this.portalController}/GetStudentDob`);
    }

    validateDob(dob: string, studentId: number): Observable<any> {
        return this._http.post<any>(
            `${this.portalController}/ValidateStudentDob/${studentId}`,
            { dob }
        );
    }

    getStudentProfile_(): Observable<StudentProfile> {
        return this._http
            .get<StudentProfile>(`${this.portalController}/GetMyProfile`)
            .pipe(shareReplay(1));
    }
    getStudentProfile(): Observable<StudentProfile> {
        return this.studentByEmailExecuted$.pipe(
            filter((executed) => executed),
            switchMap(() => {
                return this._http
                    .get<StudentProfile>(
                        `${this.portalController}/GetMyProfile`
                    )
                    .pipe(shareReplay(1));
            })
        );
    }

    getYouthWorkers(): Observable<YouthWorkerModel> {
        return this._http.get<YouthWorkerModel>(
            `${this.portalController}/MyYouthWorkers`
        );
    }

    getStaffAvatar(assetId: number): Observable<any> {
        return this._http
            .get(`${this.portalController}/staffavatar/${assetId}`, {
                responseType: 'arraybuffer',
            })
            .pipe(map((data) => new Blob([data])));
    }

    getStudentAvatar(): Observable<any> {
        return this._http.get(`${this.portalController}/MyAvatar`, {
            responseType: 'blob',
        });
    }

    getAvatarById(id: number): Observable<any> {
        return this._http.get(`${this.portalController}/Avatar/${id}`, {
            responseType: 'blob',
        });
    }

    uploadStudentAvatar(avatarData: NewAsset): Observable<NewAsset> {
        return this._http.post<NewAsset>(
            `${this.portalController}/MyAvatar`,
            avatarData
        );
    }
}
